/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles, Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';

const CustomButtonIcon = props => {
  const theme = useTheme();
  const {
    size,
    name,
    id,
    onClick,
    children,
    tooltip,
    tooltipTitle,
    width,
    height,
    marginTop,
    customBorderRadius,
  } = props;

  const useStyles = makeStyles({
    icon: {
      borderRadius: customBorderRadius ?? '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      width,
      height,
      '&:hover': {
        backgroundColor: '#EFE8F0',
      },
      '&:active': {
        backgroundColor: '#E2C7E7',
        '& $label': {
          color: '#45505E',
        },
      },
      marginTop,
    },
    iconDark: {
      borderRadius: customBorderRadius ?? '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      width,
      height,
      '&:hover': {
        backgroundColor: '#EFE8F0',
        '& $labelDark': {
          color: '#45505E',
        },
      },
      '&:active': {
        backgroundColor: '#E2C7E7',
        '& $labelDark': {
          color: '#45505E',
        },
      },
      marginTop,
    },
    labelDark: {
      color: '#E1BEE7',
    },
    label: {
      color: '#45505E',
    },
  });
  const classes = useStyles();

  const childComponent = React.Children.map(children, child =>
    React.cloneElement(child, {
      className: theme.palette.type === 'light' ? classes.label : classes.labelDark,
    })
  );

  if (tooltip) {
    return (
      <Tooltip arrow title={<h3>{tooltipTitle}</h3>}>
        <div
          name={name}
          id={id}
          key={id}
          size={size}
          className={theme.palette.type === 'light' ? classes.icon : classes.iconDark}
          onClick={onClick}
          role="presentation"
        >
          {childComponent}
        </div>
      </Tooltip>
    );
  }

  return (
    <div
      name={name}
      id={id}
      size={size}
      className={theme.palette.type === 'light' ? classes.icon : classes.iconDark}
      onClick={onClick}
      role="presentation"
    >
      {childComponent}
    </div>
  );
};

CustomButtonIcon.propTypes = {
  size: PropTypes.object.isRequired,
  name: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  width: PropTypes.object.isRequired,
  height: PropTypes.object.isRequired,
  id: PropTypes.object.isRequired,
  tooltip: PropTypes.bool.isRequired,
  tooltipTitle: PropTypes.object.isRequired,
  customBorderRadius: PropTypes.object.isRequired,
};

export default CustomButtonIcon;
